"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEmployerEmployeeSearchStore = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
/* istanbul ignore next */
function useEmployerEmployeeSearchStore() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.employerEmployeeSearchStoreKey)();
}
exports.useEmployerEmployeeSearchStore = useEmployerEmployeeSearchStore;
//# sourceMappingURL=use-api.js.map